export default "__VITE_ASSET__CWmgIwiN__"